import type {
  DocumentVersionMetaSchema,
  GetTicketApiResponse,
  TicketDocument as K2TicketDocument,
} from '~/api/k2/typedefs.autogen';

import { k2 } from '~/services/serviceInstances';

export type GetTicketDocumentRequest = {
  ticketId: string;
  documentId: string;
  version: number;
};

export type ResolvedTicketDocument = {
  fileName: string;
  fileType: string | null;
  lastModified: Date;
};

export const getTicketDocument = async ({
  ticketId,
  documentId,
  version,
}: GetTicketDocumentRequest): Promise<ResolvedTicketDocument> => {
  const response: GetTicketApiResponse = await k2.get(`/tickets/${ticketId}`, {
    params: { include: ['documents'] },
  });

  const document = response.data.attributes.documents?.find(
    (candidate: K2TicketDocument) => candidate.document_id === documentId,
  );
  if (!document) {
    throw new Error('Document not found.');
  }

  const versionEntry = document.version_history?.find(
    (entry: DocumentVersionMetaSchema) => entry.version === version,
  );

  return {
    fileName: document.name,
    fileType: versionEntry?.file_format ?? null,
    //l10n-ignore: API parsing no formatting required
    lastModified: new Date(versionEntry?.created_at ?? Date.now()),
  };
};
